<div class="layout-column custom-panel full-width full-height padding-10 gap-5">
  <!-- Header -->
  <div class="layout-column gap-5">
    <div class="layout-column">
      <div class="layout-row justify-content-between align-items-center">
        <div class="layout-row gap-5 align-items-center">
          <bringoz-icon iconName="BOX" class="gray-100"></bringoz-icon>
          <span class="flex font-weight-600 gray-100 br-body-1">{{'Split Packages Job' | translate:{jobId: jobId} }}</span>
        </div>
        <bringoz-button type="tertiary"
                        (click)="close()"
                        size="sm">
          <bringoz-icon iconName="close"></bringoz-icon>
        </bringoz-button>
      </div>
      <div *ngIf="currentPhase === FeaturePhase.SPLIT_AND_ASSIGN" class="layout-row gap-5 align-items-center">
        <span class="flex font-weight-400 gray-100 br-body-1">{{'Assign Selected Packages On A Route' | translate}}</span>
      </div>
    </div>
    <div class="header-bottom-border"></div>
  </div>

  <ng-container *ngIf="currentPhase === FeaturePhase.SPLIT; else SplitAndAssign">

    <!-- Content -->
    <div class="flex layout-column package-content ">
      <ng-container *ngIf="packages?.length > 0; else noPackages">
        <div class="layout-column" *ngFor="let pkg of packages; trackBy: trackByPackageId; let i = index; let last = last">
          <div class="flex layout-column">
            <div class="package-row layout-row align-items-center gap-5"
                 [ngClass]="{ 'anchor': lastSelectedPackage.id === pkg.id && isShiftPressed }">

              <input type="checkbox"
                     [checked]="pkg.selected"
                     (change)="onPackageSelect(pkg, i)">

              <div *ngIf="pkg.barcode" class="flex-25 layout-row layout-align-start center gap-5">
                <span class="text-ellipsis" [ngbTooltip]="pkg.barcode">{{ pkg.barcode }}</span>
                <span>|</span>
              </div>

              <div class="layout-row justify-content-around gap-5">
                <span>{{ pkg.weight | bringozWeight:true:'':true:2 }} </span>
                <span>|</span>
              </div>


              <div class="layout-row justify-content-around gap-5">
                <span>{{ pkg.pallets ?? 0 }}</span>
                <span translate>Pallets</span>
                <span>|</span>
              </div>

              <div class="layout-row justify-content-around gap-5">
                <span>{{ (pkg.volume ? pkg.volume : pkg.dimensions?.cube) | bringozVolume:true }}</span>
                <span>|</span>
              </div>

              <span class="original-count">{{'Original-short' | translate}}: {{ pkg.originalCount }}</span>

              <div class="flex layout-row justify-content-between">
                <span class="flex"></span>
                <input type="number"
                       [class.invalidInput]="isPackageInvalid(pkg)"
                       [ngModel]="pkg.selected ? pkg.count : 0"
                       (ngModelChange)="onCountChange($event, pkg, i)"
                       [disabled]="!pkg.selected || sitePackageItemsMap[pkg.size]?.splitSettings?.splitType !== 'BY_COUNT'"
                       min="1"
                       #packageInput
                       (keyup.enter)="packageInput.blur()">
              </div>
            </div>

            <hr *ngIf="!last">
          </div>
        </div>
      </ng-container>
      <ng-template #noPackages>
        <div class="flex layout-column align-items-center justify-content-center">
          <span translate>No Packages</span>
          <bringoz-icon iconName="package-outline" classSize="xxl"></bringoz-icon>
        </div>
      </ng-template>
    </div>

    <div class="layout-row padding-10-5">
      <span class="flex"></span>

      <!--Weight-->
      <bringoz-icon iconName="weight" class="bringoz-icon margin-left-10"></bringoz-icon>
      <div class="layout-row justify-content-around gap-5">
        <span>{{ selectedTotals.weight | bringozWeight:true:'':true:2 }} </span>
      </div>

      <!--Pallets-->
      <bringoz-icon iconName="pallets" class="bringoz-icon margin-left-10"></bringoz-icon>
      <div class="layout-row justify-content-around gap-5">
        <span>{{ selectedTotals.pallets ?? 0 | number: '1.0-2' }}</span>
        <span translate>Pallets</span>
      </div>

      <!--Volume-->
      <bringoz-icon iconName="volume" class="bringoz-icon margin-left-10"></bringoz-icon>
      <div class="layout-row justify-content-around gap-5">
        <span>{{ selectedTotals.volume | bringozVolume:true }}</span>
      </div>

      <!--Packages-->
      <bringoz-icon iconName="package" class="bringoz-icon margin-left-10"></bringoz-icon>
      <div class="layout-row justify-content-around gap-5">
        <span>{{ selectedPackages | servicePackagesCount }}</span>
        <span translate>Packages</span>
      </div>
    </div>

    <!-- Footer -->
    <div class="layout-column gap-5">
      <div class="footer-border-top"></div>
      <div class="layout-row justify-content-between">
        <bringoz-button size="sm" type="tertiary"
                        (click)="close()">
          <span translate>Cancel</span>
        </bringoz-button>
        <div class="layout-row gap-5">
          <bringoz-button size="sm" theme="secondary" type="outline"
                          [isDisabled]="!canSplit()"
                          (click)="setFeaturePhase(FeaturePhase.SPLIT_AND_ASSIGN)">
            <span translate>Split And Assign</span>
          </bringoz-button>
          <bringoz-button size="sm" theme="secondary"
                          [isDisabled]="!canSplit()"
                          (click)="split()">
            <span translate>Split</span>
          </bringoz-button>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #SplitAndAssign>

    <!-- Content -->
    <div class="flex layout-column gap-5 overflow-y-auto">
      <div class="padding-5-8">
        <app-bringoz-search-input placeholder="{{'Search Route / Resource' | translate}}"
                                  (queryChangeEvent)="onQueryChange($event)">
        </app-bringoz-search-input>
      </div>

      <div class="flex layout-column padding-6-8">
        <!-- Table Headers -->
        <div class="layout-column gap-5">
          <div class="tr layout-row layout-align-between-center gap-5" id="header">
            <div class="th br-body-1 font-weight-400 gray-100 flex-30">{{'Resource' | translate}}</div>
            <div class="th br-body-1 font-weight-400 gray-100 flex-25">{{'Route' | translate}}</div>
            <div class="th br-body-1 font-weight-400 gray-100 flex">{{'Weight C.' | translate}}</div>
            <div class="th br-body-1 font-weight-400 gray-100 flex">{{'Volume C.' | translate}}</div>
            <div class="th br-body-1 font-weight-400 gray-100 flex">{{'Pallet C.' | translate}}</div>
          </div>
          <div class="header-bottom-border"></div>
        </div>
        <!-- Table Content -->
        <div class="layout-column">
          <div *ngFor="let resource of resourcesToShow; let i = index; trackBy: trackByResourceId"
               class="tr layout-row layout-align-between-center gap-10 padding-6-0 height-30">
            <!-- Resource Name -->
            <div class="td flex-30 layout-row layout-align-start-center gap-5">
              <app-bringoz-radio-button [name]="'selectedResource'"
                                        [value]="resource"
                                        (onValueChange)="onResourceSelect($event)"/>
              <bringoz-icon iconName="{{resource.vehicleType.type.toLowerCase()}}" class="gray-100" classSize="sm"
                            [ngbTooltip]="resource.vehicleType.type"></bringoz-icon>
              <span class="text-ellipsis br-body-1 font-weight-400 gray-100" [ngbTooltip]="resource.allocationName || resource.vehicleName">
                {{  resource.allocationName || resource.vehicleName }}
              </span>
            </div>
            <!-- Route Name -->
            <div class="td flex-25">
              <span *ngIf="resource.routeName" class="layout-row text-ellipsis br-body-1 font-weight-400 gray-100" [ngbTooltip]="resource.routeName">
                {{ resource.routeName }}
              </span>
              <span *ngIf="!resource.routeName" class="br-body-1 font-weight-400 gray-102 font-italic" translate>Create New Route</span>
            </div>
            <!-- Updated Weight / Volume / Pallets -->
            <ng-container *ngIf="calculateUpdatedDetails(resource) as updatedDetails">
              <div class="td flex">
                <span class="br-body-1 font-weight-400" [style.color]="updatedDetails.weightPercentage && updatedDetails.weightPercentage > 1 ? 'red' : ''">{{ updatedDetails.weightPercentage ? (updatedDetails.weightPercentage | percent) : '---' }}</span>
              </div>
              <div class="td flex">
                <span class="br-body-1 font-weight-400" [style.color]="updatedDetails.volumePercentage && updatedDetails.volumePercentage > 1 ? 'red' : ''">{{ updatedDetails.volumePercentage ? (updatedDetails.volumePercentage | percent) : '---' }}</span>
              </div>
              <div class="td flex">
                <span class="br-body-1 font-weight-400"> {{ updatedDetails.pallets ?? '---' }}</span>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="layout-column footer-border-top gap-5">
      <div class="footer-border-top"></div>
      <div class="layout-row justify-content-between">
        <bringoz-button size="sm" type="tertiary"
                        (click)="setFeaturePhase(FeaturePhase.SPLIT)">
          <span translate>Back</span>
        </bringoz-button>
        <div class="layout-row gap-20">
          <div class="flex layout-row gap-5 layout-align-start-center">
            <input type="checkbox" [(ngModel)]="optimize" [disabled]="!selectedResource || !selectedResource.routeName"/>
            <span translate [class.disabled]="!selectedResource || !selectedResource.routeName">Optimize Route</span>
          </div>
          <bringoz-button size="sm" theme="secondary"
                          [isDisabled]="!this.selectedResource"
                          (click)="assign()">
            <span translate>Assign</span>
          </bringoz-button>
        </div>
      </div>
    </div>
  </ng-template>
</div>
